import React from 'react'

export default function GradeCell({grade}) {

    function GetGradeColor() {
        let color = "#FFFFFF";
    
        if (grade > 0 &&  grade < 65)  color = "#FF0000";
        if (grade > 64 && grade < 71)  color = "#FFA500";
        if (grade > 70 && grade < 81)  color = "#FFFF00";
        if (grade > 80 && grade < 91)  color = "#32CD32";
        if (grade > 90)  color = "#1E90FF";
    
    return (<td className="text-center p-2" style={{backgroundColor: `${color}`}}>   {grade}  </td>);
    
      }
  return (
    GetGradeColor()
  )
}
